import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import ArtefactSelector from "../components/ArtefactSelector";
import {connect} from "react-redux";
import {
    getDatasetsMappingSet,
    getDdbConnectionsMappingSet,
    selectConnectionMappingSet,
    selectDatasetMappingSet
} from "../actions";
import Call from "../../../../../hocs/call";
import {GUTTER_MD, TABLE_COL_MIN_WIDTH_ID} from "../../../../../styles/constants";

const mapStateToProps = (state) => ({
    selectedConnection: state.scenes.mappingHandler.mappingSet.wizard.selectedConnection,
    selectedDataset: state.scenes.mappingHandler.mappingSet.wizard.selectedDataset,
    selectedMappingSet: state.scenes.mappingHandler.mappingSet.wizard.selectedMappingSet,
    datasets: state.scenes.mappingHandler.mappingSet.wizard.datasets,
    connections: state.scenes.mappingHandler.mappingSet.wizard.connections,
    username: state.app.user.username,
    token: state.app.user.token,
    permissions: state.app.user.permissions,
    email: state.app.user.email,
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchConnections: ({username, permissions, token, email}) => dispatch(getDdbConnectionsMappingSet({
            username,
            permissions,
            token,
            email,
            metadataFlow: [],
            dataflow: [],
            isAuthenticated: true,
            dbbConnections: []
        })),
        fetchDatasets: ({connId, username}) => dispatch(getDatasetsMappingSet(connId, username)),
        onSelectConnection: (selectedConnection, shouldEraseStash) => dispatch(selectConnectionMappingSet(selectedConnection, shouldEraseStash)),
        onSelectDataset: (selectedDataset, shouldEraseStash) => dispatch(selectDatasetMappingSet(selectedDataset, shouldEraseStash)),
    }
}

const DatasetSelection = ({
                              t,
                              selectedConnection,
                              selectedDataset,
                              selectedMappingSet,
                              datasets,
                              connections,
                              username,
                              token,
                              permissions,
                              email,
                              fetchConnections,
                              fetchDatasets,
                              onSelectConnection,
                              onSelectDataset
                          }) => {
    return (
        <div style={{minHeight: "50vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
            <div style={{minWidth: "70%"}}>
                <Call cb={fetchConnections} cbParam={{username, permissions, token, email}}
                      disabled={!!selectedConnection || !username}>
                    <Call cb={fetchDatasets} cbParam={{connId: selectedConnection ? selectedConnection.entityId : null, username}}
                          disabled={!selectedConnection || !!selectedDataset || !username || !!selectedMappingSet}>
                        <ArtefactSelector value={selectedConnection ? selectedConnection.connectionName : null} choices={connections}
                                          onChange={(selectedConnection) => onSelectConnection(selectedConnection, true)} disabled={!connections || !!selectedMappingSet}
                                          columns={[
                                              {
                                                  title: t('scenes.mappingHandler.MappingSet.wizard.steps.first.connection.columns.name'),
                                                  dataIndex: 'connectionName',
                                                  minWidth: TABLE_COL_MIN_WIDTH_ID
                                              },
                                              {
                                                  title: t('scenes.mappingHandler.MappingSet.wizard.steps.first.connection.columns.dbName'),
                                                  dataIndex: 'database',
                                                  minWidth: TABLE_COL_MIN_WIDTH_ID,
                                              },
                                              {
                                                  title: t('scenes.mappingHandler.MappingSet.wizard.steps.first.connection.columns.dbType'),
                                                  dataIndex: 'dbTypeDescription',
                                                  minWidth: TABLE_COL_MIN_WIDTH_ID,
                                              },
                                          ]}
                                          modalTitle={t("scenes.mappingHandler.MappingSet.wizard.steps.first.connection.selectorModalTitle")}
                                          selectTitle={t("scenes.mappingHandler.MappingSet.wizard.steps.first.selectorTitle")}
                                          resetTitle={t("scenes.mappingHandler.MappingSet.wizard.steps.first.resetTitle")}
                                          style={{marginBottom: GUTTER_MD}}
                                          label={t('scenes.mappingHandler.MappingSet.wizard.steps.first.connection.label')}
                        />
                        <ArtefactSelector value={selectedDataset ? selectedDataset.name : null} choices={datasets}
                                          onChange={(selectedDataset) => onSelectDataset(selectedDataset, true)}
                                          disabled={!datasets || !selectedConnection || !!selectedMappingSet}
                                          columns={[
                                              {
                                                  title: t('scenes.mappingHandler.MappingSet.wizard.steps.first.dataset.columns.name'),
                                                  dataIndex: 'name',
                                                  minWidth: TABLE_COL_MIN_WIDTH_ID
                                              },
                                          ]}
                                          modalTitle={t("scenes.mappingHandler.MappingSet.wizard.steps.first.dataset.selectorModalTitle")}
                                          selectTitle={t("scenes.mappingHandler.MappingSet.wizard.steps.first.selectorTitle")}
                                          resetTitle={t("scenes.mappingHandler.MappingSet.wizard.steps.first.resetTitle")}
                                          label={t('scenes.mappingHandler.MappingSet.wizard.steps.first.dataset.label')}
                        />
                    </Call>
                </Call>
            </div>
        </div>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(DatasetSelection);